<template>
  <div class="no-bids d-flex align-center justify-center">
    <div class="text-center">
      <v-img class="mb-6 mx-auto" src="@/assets/img/cheque.png" width="72px" height="72px"></v-img>
      <h3 class="font font--h3 mb-2">Список вознаграждений пуст</h3>
      <p class="font font--p-sm mb-6">Создайте свою первую заявку, чтобы получить вознаграждение</p>
      <!-- <v-btn :disabled="!canCreateApp" color="primary" @click="showNewBidModal(true)">+ Новая заявка</v-btn> -->
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  methods: {
    ...mapMutations("common", ["showNewBidModal"]),
  },
  computed: mapGetters("profile", ["canCreateApp"]),
};
</script>

<style lang="scss" scoped>
.no-bids::before {
  content: "";
  min-height: 350px;
}
@media (max-width: 360px) {
  p {
    max-width: 244px;
  }
}
</style>
